import * as Dates from '../Dates';

/**
 * Format a forecast-map timestamp (run time / frame valid time) for display.
 *
 * The manifest's `time` and `run_datetime` arrive from the API as Unix epoch
 * SECONDS (the backend's DRF `DATETIME_FORMAT="%s"`), not ISO strings — despite
 * the field name and the `string` type. The previous code did
 * `Dates.formatDate(moment(value).unix(), …)`, and `moment()` reads the epoch
 * number as MILLISECONDS, landing on 1970-01-21 (~16:24) — a garbage date the
 * year-less `ddd D MMM` format silently hid.
 *
 * Treat the value as seconds and go straight through the core Dates helper so
 * it honours the user's 24h/12h preference (`dateTimeConfig`), timezone and
 * moment locale.
 */
export const formatForecastTimeLabel = (
  value: string | number,
  timezone: string,
  dateTimeConfig: Parameters<typeof Dates.hourFormatter>[0],
  // Moment format. Defaults to the date + the user's 24h/12h hour (with
  // minutes); callers that show whole-hour times (e.g. model runs) can pass a
  // minute-less format such as `ddd D MMM, HH`.
  format = `ddd D MMM, ${Dates.hourFormatter(dateTimeConfig)}`,
): string => {
  const seconds = Number(value);
  if (!Number.isFinite(seconds)) {
    return '-';
  }
  return Dates.formatDate(seconds, timezone, format);
};

export default formatForecastTimeLabel;
